// extracted by mini-css-extract-plugin
module.exports = {"container":"PlatformLoader_container__RkcnM","svgLoader":"PlatformLoader_svgLoader__DpR9m","shimmer":"PlatformLoader_shimmer__AcYW6"};